import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import ApiService from "../../network/ApiService";
import {
  setOrgDetailData,
  setContactListData,
} from "../../state/reducers/ContactListReducers";
import { setLanguage } from "../../state/reducers/OrganizationReducer";

function TopBar() {
  const dispatch = useDispatch();

  const { organizationId, language } = useSelector(
    (state) => state.organization
  );

  const orgDetail =
    useSelector((state) => state.contact.orgDetailData) || {};
  const contactsList =
    useSelector((state) => state.contact.contactListData) || [];

  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [messages, setMessages] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [showSearchList, setShowSearchList] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const api = useMemo(() => ApiService(), []);
  const { fetchMessages, fetchOrgDetail } = api;

  useEffect(() => {
    if (!organizationId) return;

    let mounted = true;
    const loadMessages = async () => {
      try {
        const res = await fetchMessages(organizationId);
        if (mounted) {
          setMessages(res.data.mapOfIdAndDisplayLabels || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadMessages();
    return () => {
      mounted = false;
    };
  }, [organizationId, fetchMessages]);

  useEffect(() => {
    if (!organizationId) return;

    let mounted = true;
    const loadOrg = async () => {
      try {
        const res = await fetchOrgDetail(organizationId);
        if (!mounted) return;

        dispatch(setOrgDetailData(res.data));
        dispatch(setContactListData(res.data.contactList || []));
      } catch (err) {
        console.error(err);
      }
    };

    loadOrg();
    return () => {
      mounted = false;
    };
  }, [organizationId, dispatch, fetchOrgDetail]);

  useEffect(() => {
    if (!contactsList.length) return;

    setPhone(contactsList.find((c) => c.contactType === "Phone"));
    setEmail(contactsList.find((c) => c.contactType === "Email"));
  }, [contactsList]);

  const changeLanguage = (lang) => {
    if (lang === language) return;
    sessionStorage.setItem("language", lang);
    dispatch(setLanguage(lang));
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toLowerCase();
    if (!value) {
      setSearchList([]);
      setShowSearchList(false);
      return;
    }

    const list = [
      { name: "Home (गृहपृष्ठ)", url: "/" },
      { name: "About Us (संस्थाको जानकारी)", url: "/about" },
      { name: "News (समाचार)", url: "/news" },
    ];

    const filtered = list.filter((item) =>
      item.name.toLowerCase().includes(value)
    );

    setSearchList(filtered);
    setShowSearchList(true);
  };

  return (
    <div
      className="topbar"
      style={{
        background: "#0f2495",
        color: "white",
        padding: "0 1rem",
      }}
    >
      <nav
        className="uk-navbar"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "0.5rem",
          padding: "0.5rem 0",
        }}
      >
        {/* LOGO */}
        <Link
          to="/"
          className="uk-navbar-item uk-logo"
          style={{
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={orgDetail?.bannerImage || "/assets/images/image.jpg"}
            alt="Banner"
            style={{
              height: "80px", // Keep original logo size
              maxWidth: "100%",
            }}
          />
        </Link>

        {/* MOBILE HAMBURGER */}
        <div
          className="mobile-menu-icon"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
            marginLeft: "auto",
          }}
        >
          {mobileMenuOpen ? "✕" : "☰"}
        </div>

        {/* SEARCH & LANGUAGE - DESKTOP */}
        <div
          className="desktop-menu"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            flexGrow: 1,
            justifyContent: "flex-end",
            flexWrap: "wrap",
          }}
        >
          {/* SEARCH */}
          <div style={{ position: "relative", flexGrow: 1, maxWidth: "200px" }}>
            <input
              type="search"
              placeholder={language === "en" ? "Search" : "खोज"}
              className="uk-search-input"
              onChange={handleInputChange}
              onFocus={() => setMobileSearchOpen(true)}
              onBlur={() => setMobileSearchOpen(false)}
              style={{
                width: "100%",
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid white",
                color: "white",
                padding: "4px 8px",
                borderRadius: "4px",
                outline: "none",
              }}
            />
            {showSearchList && searchList.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "110%",
                  left: 0,
                  backgroundColor: "white",
                  color: "#0f2495",
                  borderRadius: "4px",
                  minWidth: "150px",
                  zIndex: 1000,
                  boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                }}
              >
                {searchList.map((item, idx) => (
                  <Link
                    key={idx}
                    to={item.url}
                    style={{
                      display: "block",
                      padding: "0.25rem 0.5rem",
                      color: "#0f2495",
                      textDecoration: "none",
                      fontSize: "0.9rem",
                    }}
                    onMouseDown={(e) => e.preventDefault()} // prevent blur
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* LANGUAGE BUTTONS */}
          <div style={{ display: "flex", gap: "0.25rem" }}>
            <button
              onClick={() => changeLanguage("en")}
              style={{
                border: "1px solid white",
                borderRadius: "4px",
                background: language === "en" ? "white" : "transparent",
                color: language === "en" ? "#0f2495" : "white",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "0.85rem",
              }}
            >
              EN
            </button>

            <button
              onClick={() => changeLanguage("np")}
              style={{
                border: "1px solid white",
                borderRadius: "4px",
                background: language === "np" ? "white" : "transparent",
                color: language === "np" ? "#0f2495" : "white",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "0.85rem",
              }}
            >
              NP
            </button>
          </div>
        </div>

        {/* MOBILE MENU */}
        {mobileMenuOpen && (
          <div
            className="mobile-menu"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              background: "#0f2495",
              padding: "0.5rem 0",
              gap: "0.5rem",
            }}
          >
            <input
              type="search"
              placeholder={language === "en" ? "Search" : "खोज"}
              className="uk-search-input"
              onChange={handleInputChange}
              style={{
                width: "100%",
                background: "rgba(255, 255, 255, 0.2)",
                border: "1px solid white",
                color: "white",
                padding: "6px 10px",
                borderRadius: "4px",
                outline: "none",
              }}
            />
            <div style={{ display: "flex", gap: "0.25rem" }}>
              <button
                onClick={() => changeLanguage("en")}
                style={{
                  border: "1px solid white",
                  borderRadius: "4px",
                  background: language === "en" ? "white" : "transparent",
                  color: language === "en" ? "#0f2495" : "white",
                  padding: "6px 10px",
                  cursor: "pointer",
                  flex: 1,
                  fontSize: "0.85rem",
                }}
              >
                EN
              </button>

              <button
                onClick={() => changeLanguage("np")}
                style={{
                  border: "1px solid white",
                  borderRadius: "4px",
                  background: language === "np" ? "white" : "transparent",
                  color: language === "np" ? "#0f2495" : "white",
                  padding: "6px 10px",
                  cursor: "pointer",
                  flex: 1,
                  fontSize: "0.85rem",
                }}
              >
                NP
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* RESPONSIVE STYLES */}
      <style>
        {`
          @media (max-width: 768px) {
            .desktop-menu {
              display: none;
            }
            .mobile-menu-icon {
              display: block;
            }
          }
          @media (min-width: 769px) {
            .mobile-menu {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TopBar;
